import SunCalc from "suncalc";

export default function getDayOrNight(time, lat, lng) {
  let cityTimes = SunCalc.getTimes(time, lat, lng);
  let dayOrNight =
    time >= cityTimes.sunrise && time <= cityTimes.sunset ? "day" : "night";

  return dayOrNight;
}
